import { render } from "./index.vue?vue&type=template&id=2ac49829&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2ac49829&lang=scss&scoped=true"

import exportComponent from "/chaopin/jpom/data/build/66617637594a40d3882f98d9518ea655/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac49829"]])

export default __exports__